var _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _g6, _path4, _g7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFormSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 257 238"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f_1969_7356)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.13,
  d: "m37.907 70.652 111.851-20.483c8.218-1.505 16.222 3.524 18.432 11.58l31.552 115.006c2.572 9.376-3.687 18.877-13.317 20.213l-115.62 16.046c-8.144 1.13-15.83-4.054-17.834-12.028L25.189 90.418c-2.268-9.026 3.564-18.09 12.718-19.766Z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_1969_7356)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint0_linear_1969_7356)",
  d: "m190.563 27.377 28.461 119.886c1.964 8.274-3.623 16.442-12.046 17.612L90.157 181.094a14.419 14.419 0 0 1-15.98-10.818L45.875 55.894c-1.859-7.51 2.983-15.038 10.588-16.46l118.532-22.177c7.058-1.32 13.91 3.133 15.568 10.12Z"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_d_1969_7356)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint1_linear_1969_7356)",
  d: "m191.045 25.454 28.46 119.886c1.965 8.275-3.622 16.443-12.046 17.612l-116.82 16.22a14.419 14.419 0 0 1-15.98-10.819L46.356 53.972c-1.858-7.51 2.984-15.038 10.589-16.46l118.531-22.178c7.058-1.32 13.91 3.133 15.569 10.12Z"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_d_1969_7356)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint2_linear_1969_7356)",
  d: "m191.525 23.532 28.461 119.886c1.964 8.274-3.623 16.442-12.046 17.612L91.119 177.249a14.419 14.419 0 0 1-15.98-10.818L46.837 52.049c-1.859-7.51 2.983-15.038 10.588-16.46l118.532-22.177c7.058-1.32 13.91 3.133 15.568 10.12Z"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_d_1969_7356)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint3_linear_1969_7356)",
  d: "m192.486 22.09 28.461 119.886c1.964 8.274-3.623 16.443-12.046 17.612L92.08 175.807c-7.31 1.015-14.207-3.654-15.98-10.818L47.797 50.607c-1.858-7.51 2.984-15.037 10.59-16.46l118.53-22.177c7.058-1.32 13.91 3.133 15.568 10.12Z"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_d_1969_7356)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint4_linear_1969_7356)",
  d: "m60.062 33.697 118.897-22.265c6.558-1.228 12.923 2.911 14.461 9.403l28.465 120.213c3.093 13.062-12.253 22.518-22.53 13.883l-94.399-79.32c-5.777-4.855-14.505-3.52-18.569 2.837L75.002 96.264c-3.672 5.747-12.452 4.225-13.976-2.422l-10.464-45.65c-1.526-6.653 2.79-13.239 9.5-14.495Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint5_linear_1969_7356)",
  d: "m64.902 99.11 140.489 58.897s-2.926-2.46-7.406-6.169c-37.616-31.14-78.029-64.9-94.873-78.986-4.685-3.918-11.53-3.848-15.29.964-2.463 3.152-5.006 7.068-6.64 11.365-6.308 16.584-16.28 13.928-16.28 13.928Z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_1969_7356",
  width: 141,
  height: 89,
  x: 65,
  y: 69,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#A05C5C",
  d: "m65.217 98.902 140.488 58.897s-2.926-2.46-7.406-6.168c-37.616-31.141-78.028-64.9-94.872-78.987-4.685-3.918-11.53-3.848-15.29.964-2.464 3.152-5.007 7.068-6.641 11.365-6.308 16.585-16.28 13.929-16.28 13.929Z"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1969_7356)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_f_1969_7356)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 188.888,
  height: 15.38,
  x: 50.187,
  y: 86.033,
  fill: "#85299C",
  transform: "rotate(24.042 50.187 86.033)"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 1.442,
  d: "M64.902 99.11s9.972 2.655 16.28-13.93c1.634-4.296 4.177-8.212 6.64-11.364 3.76-4.812 10.605-4.882 15.29-.965 16.844 14.087 57.257 47.847 94.873 78.987 4.48 3.709 7.406 6.169 7.406 6.169"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter7_f_1969_7356)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#781991",
  fillOpacity: 0.39,
  fillRule: "evenodd",
  d: "m68.76 102.748-6.094-2.556s9.972 2.656 16.279-13.928c1.634-4.297 4.178-8.213 6.64-11.365 3.732-4.774 10.5-4.88 15.181-1.055-3.782-.908-7.8.165-10.375 3.458-2.463 3.152-5.006 7.068-6.64 11.365-4.928 12.956-12.092 14.17-14.99 14.081Z",
  clipRule: "evenodd"
}))))), /*#__PURE__*/React.createElement("g", {
  opacity: 0.8
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask1_1969_7356",
  width: 173,
  height: 148,
  x: 50,
  y: 9,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint6_linear_1969_7356)",
  d: "M60.542 32.255 179.44 9.99c6.557-1.228 12.923 2.912 14.46 9.403l28.466 120.213c3.093 13.062-12.253 22.519-22.53 13.883l-94.399-79.32c-5.777-4.855-14.506-3.52-18.57 2.838L75.483 94.823c-3.672 5.746-12.451 4.224-13.975-2.423L51.042 46.75c-1.525-6.653 2.791-13.238 9.5-14.495Z"
}))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_1969_7356)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter8_f_1969_7356)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FCEEFF",
  fillOpacity: 0.4,
  d: "M88.14 82.168c0 10.751-8.715 19.466-19.465 19.466-10.751 0-19.466-8.715-19.466-19.466 0-10.75 8.715-3.124 19.466-3.124 10.75 0 19.465-7.626 19.465 3.124Z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter9_f_1969_7356)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 130.128,
  height: 13.077,
  x: 102.325,
  y: 75.536,
  fill: "#A83EC3",
  transform: "rotate(35.047 102.325 75.536)"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#A737C4",
  strokeLinecap: "round",
  strokeWidth: 8.858,
  d: "m125.166 62.465 18.376 15.044 23.077-37.948M134.829 98.7l18.376 15.045 23.077-37.948"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_1969_7356",
  width: 223.939,
  height: 211.579,
  x: 0.541,
  y: 25.746,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1969_7356",
  stdDeviation: 12.079
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_1969_7356",
  width: 174.903,
  height: 165.169,
  x: 44.996,
  y: 17.025,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.481
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.24
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1969_7356"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1969_7356",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_d_1969_7356",
  width: 174.903,
  height: 165.169,
  x: 45.477,
  y: 15.103,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.481
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.24
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1969_7356"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1969_7356",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_d_1969_7356",
  width: 174.903,
  height: 165.169,
  x: 45.958,
  y: 13.18,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.481
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.24
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1969_7356"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1969_7356",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_d_1969_7356",
  width: 174.903,
  height: 165.169,
  x: 46.919,
  y: 11.738,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.481
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.24
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1969_7356"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1969_7356",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_d_1969_7356",
  width: 197.757,
  height: 222.338,
  x: 38.154,
  y: 6.248,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -2.884,
  dy: 11.535
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.364
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1969_7356"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1969_7356",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_f_1969_7356",
  width: 192.225,
  height: 104.457,
  x: 37.192,
  y: 79.304,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1969_7356",
  stdDeviation: 3.364
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7_f_1969_7356",
  width: 47.712,
  height: 41.233,
  x: 57.86,
  y: 66.325,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1969_7356",
  stdDeviation: 2.403
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter8_f_1969_7356",
  width: 62.002,
  height: 48.284,
  x: 37.674,
  y: 64.885,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1969_7356",
  stdDeviation: 5.768
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter9_f_1969_7356",
  width: 175.564,
  height: 146.953,
  x: 64.055,
  y: 44.775,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1969_7356",
  stdDeviation: 15.38
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1969_7356",
  x1: 133.477,
  x2: 129.8,
  y1: 9.846,
  y2: 184.529,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5ADF3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E9C6F1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1969_7356",
  x1: 133.959,
  x2: 130.282,
  y1: 7.923,
  y2: 182.606,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5ADF3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E9C6F1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1969_7356",
  x1: 134.439,
  x2: 130.762,
  y1: 6.001,
  y2: 180.684,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5ADF3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E9C6F1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_1969_7356",
  x1: 135.4,
  x2: 131.723,
  y1: 4.559,
  y2: 179.242,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5ADF3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E9C6F1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_1969_7356",
  x1: 123.354,
  x2: 154.467,
  y1: 21.845,
  y2: 171.105,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F7DAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DE89F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_1969_7356",
  x1: 117.939,
  x2: 104,
  y1: 86.033,
  y2: 115.352,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F7D7FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC52D7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_1969_7356",
  x1: 123.834,
  x2: 154.947,
  y1: 20.403,
  y2: 169.663,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F7DAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DE89F3"
})))));
export { SvgFormSuccess as ReactComponent };
export default __webpack_public_path__ + "static/formSuccess.af888456.svg";